<template>
  <PageSection :use-alternate-bg-color="useAlternateBgColor">
    <PageContainer>
      <PageHeading
        tag-name="h1"
        :margin-bottom="3"
      >
        {{ $t('csr.section.what.title') }}
      </PageHeading>

      <div :class="$style.row">
        <PageCardContent
          v-for="item in items"
          :key="item.image"
          :class="$style.card"
          :image="item.image"
          :content="item.content"
          :content-class="$style.content"
        />
      </div>
    </PageContainer>
  </PageSection>
</template>

<script lang="ts">
import PageCardContent, { PageCardContentProps } from '@/scripts/pages/onepager/components/PageCardContent.ts.vue';
import PageSection from '@/scripts/pages/onepager/components/PageSection.ts.vue';
import PageContainer from '@/scripts/pages/onepager/components/PageContainer.ts.vue';
import PageHeading from '@/scripts/pages/onepager/components/PageHeading.ts.vue';
import { CsrBaseComponent } from '../components/CsrBaseComponent';
import { WHAT_SECTION_IMAGES } from '../assets/media';

export default CsrBaseComponent.extend({
  components: {
    PageCardContent,
    PageSection,
    PageContainer,
    PageHeading,
  },
  props: {
    useAlternateBgColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const localeItems: { title: string; paragraphs: string[] }[] = this.$t('csr.section.what.items');
    const items: PageCardContentProps[] = localeItems.map(({ title, paragraphs }, index) => ({
      content: {
        title,
        paragraphs,
        titleClass: this.$style.contentTitle,
        paragraphClass: this.$style.contentParagraph,
      },
      image: WHAT_SECTION_IMAGES[index],
    }));

    return {
      items,
    };
  },
});
</script>

<style lang="scss" module>
@import '~@/scripts/pages/onepager/styles/variables-entry';
@import '~@/scripts/pages/onepager/styles/variables';

.row {
  display: flex;
  flex-wrap: wrap;
  margin-left: $grid-gutter-width / -2;
  margin-right: $grid-gutter-width / -2;
  gap: 2.5rem;
  @include media-breakpoint-up($page-breakpoint-switch) {
    flex-wrap: nowrap;
    padding-left: $grid-gutter-width / 2;
    padding-right: $grid-gutter-width / 2;
    gap: 2rem;
  }
}

.card {
  @include media-breakpoint-up($page-breakpoint-switch) {
    $width: 100% / 3;
    width: $width;
    flex: 1 1 $width;
  }
}

.content {
  padding-left: $grid-gutter-width / 2;
  padding-right: $grid-gutter-width / 2;
  @include media-breakpoint-up($page-breakpoint-switch) {
    padding-left: 0;
    padding-right: 0;
  }
}

.contentTitle {
  text-align: left;
  @include media-breakpoint-up($page-breakpoint-switch) {
    text-align: center;
  }
}
</style>
